import React from 'react';

import Grid from '@material-ui/core/Grid';

import CellActivities from '../../Cell/Activities';

import IntlMessage from '../../../LocaleEngine';

/*
*/
export default function ListGroup(props) {
    const {showImages = true} = props;

    const addToCart = (element, amount, callback) => {
        props.addToCart(element, amount, callback)
    }
    if(!props.list || (props.list && props.list.length <= 0)){
        return (
            <span className="error"><IntlMessage id="activities.list.groups.no_products_available" /></span>
        );
    }
    return (
        <Grid container spacing={0} className={props.open !== null ? "groups closed" :"groups"}>
        {
            Array.isArray(props.list) ? props.list.map((element, index) => {
                return <CellActivities maxQuantity={props.maxQuantity} dateOfActivity={props.dateOfActivity} showUnspanned={props.showUnspanned} displayType={props.displayType} isPackage={props.isPackage} open={props.open} toggleSupplier={props.toggleSupplier.bind(this)} configuration={props.configuration} showImages={showImages} addToCart={addToCart.bind(this)} key={index} index={index} element={element} />
            })
            :
            <CellActivities maxQuantity={props.maxQuantity} dateOfActivity={props.dateOfActivity} showUnspanned={props.showUnspanned} displayType={props.displayType} isPackage={props.isPackage} open={props.open} toggleSupplier={props.toggleSupplier.bind(this)} configuration={props.configuration} showImages={showImages} addToCart={addToCart.bind(this)} element={props.list} />
        }
        </Grid>
    )
}
